/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Select_ResumeInputs */

const en_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const de_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const fr_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const es_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const it_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const nl_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const pl_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const fi_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const da_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const sv_deep_match_select_resume = /** @type {(inputs: Deep_Match_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

/**
* | output |
* | --- |
* | "Select a resume..." |
*
* @param {Deep_Match_Select_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_select_resume = /** @type {((inputs?: Deep_Match_Select_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Select_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_select_resume(inputs)
	if (locale === "fr") return fr_deep_match_select_resume(inputs)
	if (locale === "es") return es_deep_match_select_resume(inputs)
	if (locale === "it") return it_deep_match_select_resume(inputs)
	if (locale === "nl") return nl_deep_match_select_resume(inputs)
	if (locale === "pl") return pl_deep_match_select_resume(inputs)
	if (locale === "fi") return fi_deep_match_select_resume(inputs)
	if (locale === "da") return da_deep_match_select_resume(inputs)
	if (locale === "sv") return sv_deep_match_select_resume(inputs)
	return en_deep_match_select_resume(inputs)
});